<template>
  <bm-dialog
    :label="$m.containers_error_dialog_title"
    :dialog-type="EnumDialogType.error"
    :cancelable="false"
    @accept="accept"
    @cancel="cancel"
  >
    <v-container fluid>
      <div v-for="text in errorMessages" :key="text">
        {{ text }}
      </div>
    </v-container>

    <template #controls-confirm-text>
      {{ $m.ok }}
    </template>
  </bm-dialog>
</template>

<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import { EnumDialogType } from "@/components/dialogs/DialogTypes";
import type { DialogEvents } from "@/components/mixins/dialogs";
import { useReactiveDialogScriptSetup } from "@/components/mixins/dialogs";

interface Props {
  errorMessages?: string[];
}

interface Events extends DialogEvents {}

defineProps<Props>();
const emit = defineEmits<Events>();

const { accept, cancel } = useReactiveDialogScriptSetup(emit);
</script>
